export const CHECKLIST_KINDS = ['ONBOARDING', 'OFFBOARDING'] as const;
export type ChecklistKind = (typeof CHECKLIST_KINDS)[number];

export const CHECKLIST_ASSIGNEES = ['EMPLOYEE', 'MANAGER'] as const;
export type ChecklistAssignee = (typeof CHECKLIST_ASSIGNEES)[number];

export const CHECKLIST_STATUSES = ['OPEN', 'DONE', 'CANCELLED'] as const;
export type ChecklistStatus = (typeof CHECKLIST_STATUSES)[number];

export const CHECKLIST_ITEM_STATUSES = ['PENDING', 'DONE', 'SKIPPED'] as const;
export type ChecklistItemStatus = (typeof CHECKLIST_ITEM_STATUSES)[number];

/** Why a person was given a checklist: the most specific template that matched them, or a manager's choice. */
export const CHECKLIST_MATCH_RULES = ['DEPARTMENT_ROLE', 'DEPARTMENT', 'ROLE', 'DEFAULT', 'MANUAL'] as const;
export type ChecklistMatchRule = (typeof CHECKLIST_MATCH_RULES)[number];
